import { memo } from 'react'
import type { NotebookNote } from '../../shared/types/notebook'
import type { SlashCommand } from '../../shared/types/chat'
import TiptapEditor from './TiptapEditor'

export type { SlashCommand }

interface RichContentEditorProps {
  value: string
  onChange: (value: string) => void
  onNavigate?: (noteId: string) => void
  allNotes: NotebookNote[]
  slashCommands?: SlashCommand[]
  onExecuteCommand?: (commandId: string) => void
  placeholder?: string
  className?: string
  autoFocus?: boolean
  minHeight?: string
}

function RichContentEditorInner(props: RichContentEditorProps) {
  return <TiptapEditor {...props} />
}

export default memo(RichContentEditorInner)
